import { Table } from "./common";
import { Empty } from "./common";
import section from "./section";

const Components = {
  section,
  
  Table,
  Empty
}

export default Components